module.exports = __webpack_public_path__ + "img/help-chat.4ac2208d.png";